import Upload from './upload';

function upload(props) {
  return new Upload(props);
}

export default upload;


//////////////////
// WEBPACK FOOTER
// ./~/codeages-design/src/lib/upload/index.js
// module id = 576
// module chunks = 9